import { PathRoutes } from 'enum/routes'

/**
 * URLs y rutas del producto para cursos normativos / constancias DC-3 (México).
 * Centralizar aquí cualquier enlace o path relacionado.
 */

/** Guía de configuración de cursos normativos (Rankmi Knowledge). */
export const DC3_CONFIGURATION_GUIDE_URL =
  'https://rankmi.odoo.com/knowledge/article/4411'

/** Ruta a Certificados > Constancias legales (plantillas DC-3). */
export const DC3_CERTIFICATE_TEMPLATES_PATH =
  PathRoutes.CERTIFICATE_TEMPLATES_LEGAL
